import * as React from 'react';
import { JobVacancy } from '../../Model/JobVacancy';
import { Type } from '../../Type';
import { BranchFilter } from '../Filter/BranchFilter';
import { IndustryFilter } from '../Filter/IndustryFilter';
import { SearchTermFilter } from '../Filter/SearchTermFilter';
import { FilterProps } from '../FilterProps';

export class CustomFilterView extends React.Component<FilterProps<JobVacancy>> {
    public render() {
        const props = this.props;
        const models = props.allModels;
        const filterSettings = props.filterSettings;
        const onChange = props.onChange;
        const className = this.getClassName(props.type);

        return <div className={className}>
            <div className="jc-upper">
                <SearchTermFilter filterSettings={filterSettings} models={models} onChange={onChange}/>
            </div>
            <div className="jc-lower row">
                <div className="col-sm-6">
                    <IndustryFilter filterSettings={filterSettings} models={models} onChange={onChange}/>
                </div>
                <div className="col-sm-6">
                    <BranchFilter filterSettings={filterSettings} models={models} onChange={onChange}/>
                </div>
            </div>
        </div>;
    }

    private getClassName(type: Type) {
        const inner = type === Type.Candidate ? 'candidate' : 'job-vacancy';

        return 'job-center-filter job-center-' + inner + '-filter';
    }
}
